export default ({
  modalReact
}) => {
  const {
    backgroundOpacity,

    zIndex, transitionDuration
  } = modalReact;
  return ({
    modalComponent: {
      zIndex: 5
    },

    root: {
      transition: `visibility ${transitionDuration}s`,
      pointerEvents: 'none',
      visibility: 'hidden',
      position: 'fixed',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex,
      outline: 0
    },

    backdrop: {
      backgroundColor: `rgba(0, 0, 0, ${backgroundOpacity})`,
      bottom: 0,
      left: 0,
      position: 'fixed',
      right: 0,
      top: 0,
      zIndex: 0
    },

    modalIn: {
      transition: 'none',
      pointerEvents: 'auto',
      overflowX: 'hidden',
      overflowY: 'auto',
      visibility: 'visible',
      display: 'block'
    }
  });
};
